import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-cedrow-side-by-side.js';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Take advantage of the offer',
  backgroundColor: '#00374c',
  color: '#ffffff',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});

const html = `
<div class="wrap-card container">
  <div data-attribute="wrap-img-with-text" class="wrap-img-with-text" data-center-y="true" data-media-position="left">
    <div
      data-media-type="video"
      data-attribute="left-card-media"
      class="left-card"
      data-order-left="1"
      style="--order-left: 1"
    >
      <div data-attribute="wrap-video" class="wrap-video">
        <video
          data-attribute="video"
          muted
          autoplay
          loop
          playsinline
          src="https://cedrow.com/cdn/shop/videos/c/vp/8f38d0ced9ea47d78bc50ef96d035863/8f38d0ced9ea47d78bc50ef96d035863.HD-1080p-7.2Mbps-84359340.mp4?v=0"
        ></video>
      </div>
      <div data-attribute="wrap-image" class="wrap-image" style="display: none">
        <img data-attribute="image" src="" alt="" />
      </div>
    </div>
    <div
      data-background-color="#ffffff"
      data-attribute="right-card-content"
      class="right-card"
      data-order-right="2"
      style="--order-right: 2; --background-color-right: #ffffff"
    >
      <div data-attribute="heading-text" class="heading-text">
        <h2>Trusted by 42,000+ for safer walking</h2>
        <p>
          “I used to be terrified of tripping, constantly watching the ground to make sure my toes didn't catch. This
          brace is lightweight and lifts my foot instantly, so I can walk naturally without thinking about every step. I
          feel steady and safe again, and I’m finally walking outdoors without the fear of falling. It’s not just a
          brace — it gave me my independence back.”
        </p>
        <p>Reviewed by Michael R.</p>
      </div>
      <div
        data-attribute="block-social-rating"
        data-show="true"
        data-color-item-social="#000000"
        data-background-item-social="#f9fbff"
        class="block-social-rating"
        style="--color-item-social: #000000; --bg-item-social: #f9fbff"
      >
        <div data-attribute="list-social-item" class="list-social-item">
          <div data-attribute="social-item" class="item-social">
            <div data-show="false" data-attribute="image-social" style="display: none">
              <img src="" alt="" />
            </div>
            <div data-attribute="title-social" class="title-social">
              <h3>Facebook</h3>
            </div>
            <div data-attribute="rating-text" class="text-reating-social">Rating 4.9</div>
            <div data-value="4" data-attribute="star-rating" class="stars">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
          <div data-attribute="social-item" class="item-social">
            <div data-show="false" data-attribute="image-social" style="display: none">
              <img src="" alt="" />
            </div>
            <div data-attribute="title-social" class="title-social">
              <h3>Google</h3>
            </div>
            <div data-attribute="rating-text" class="text-reating-social">Rating 4.9</div>
            <div data-value="5" data-attribute="star-rating" class="stars">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
          <div data-attribute="social-item" class="item-social">
            <div data-show="false" data-attribute="image-social" style="display: none">
              <img src="" alt="" />
            </div>
            <div data-attribute="title-social" class="title-social">
              <h3>Cedrow</h3>
            </div>
            <div data-attribute="rating-text" class="text-reating-social">Rating 4.9</div>
            <div data-value="3" data-attribute="star-rating" class="stars">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#00374c',
  topPadding: true,
  bottomPadding: true,
});
